import { formatCurrency } from "@/utils/currency";
import { abbreviateNumber } from "@/utils/number";

export default {
  methods: {
    formatCurrency,
    abbreviateNumber
  }
};
